<template>
  <div class="wrapper">
    <!-- 活动简介 -->
    <div class="activity_summary l_flex_column_center">
      <h3 class="title">活动简介</h3>
      <img src="~@/assets/img/icon.png" class="icon" alt="" />
      <p class="text">
        习近平总书记指出，“中华优秀传统文化是我们最深厚的文化软实力，也是中国特色社会主义植根的文化沃土”。《中华传统文化百部经典》（以下简称《百部经典》）是以习近平新时代中国特色社会主义思想为指导，将优秀传统文化与社会主义核心价值观深度契合，以当代眼光审视和解答古代典籍，为广大读者提供的一套古代典籍普及读本。
      </p>
      <p class="text">
        为进一步深入贯彻落实习近平总书记在给国家图书馆老专家的回信精神，提升大学生群体对中华传统文化的理解和认知，更好地继承和弘扬优秀传统文化，国家图书馆、中国图书馆学会将开展“读百部经典 品千年文化”——《中华传统文化百部经典》校园行活动。
      </p>
    </div>
    <!-- 活动规则介绍 -->
    <div class="activity_rule">
      <h3 class="title">活动入口</h3>
      <img src="~@/assets/img/icon.png" class="icon" alt="" />

      <!-- <img src="../../../assets/img/title4.png" alt="活动规则介绍" class="activity_rule_title" /> -->
      <div class="activity_rule_list">
        <activity-item v-for="item in activityList" :key="item.id" :data="item"></activity-item>
      </div>
    </div>
    <!-- 活动流程 -->
    <div class="activity_process l_flex_column_center">
      <h3 class="title">活动流程</h3>
      <img src="~@/assets/img/icon.png" class="icon" alt="" />
      <div class="time-con l_flex_row_between">
        <div class="time-box">
          <p class="time-box-title">组织单位报名阶段</p>
          <p>2021年12月1日</p>
          <p class="line"></p>
          <p>2022年4月30日</p>
        </div>
        <div class="time-box">
          <img src="~@/assets/img/bot_right.png" class="right_icon" alt="" />
          <img src="~@/assets/img/top_right.png" class="right_icon1" alt="" />
          <p class="time-box-title">校内征集阶段</p></p>
          <p>2021年12月15日</p>
          <p class="line"></p>
          <p>2022年4月30日</p>
        </div>
        <div class="time-box">
          <p class="time-box-title">活动总结及作品展示阶段</p>
          <p>2022年6月1日</p>
          <p class="line"></p>
          <p>6月30日</p>
        </div>
      </div>
      <div class="content">
        <p class="second-title">（一）组织单位报名阶段：2021年12月1日至2022年4月30日</p>
        <p>
          各高校图书馆报名成为组织单位。登录官方网站（网址：https://www.yulin365.net/lsc）进行报名，填写图书馆相关信息并提交，经审核成功后可登录组织单位管理后台，查看本单位征集情况实时数据，并对征集到的作品进行管理。
        </p>
        <p class="second-title">
          （二）校内征集阶段：2021年12月15日至2022年4月30日
        </p>
        <p>
          在校学生、教职员工均可注册参与活动。通过活动官方网站或已登记为活动组织单位的学校图书馆微信公众号进入活动页面，按照平台提示完成个人账户的注册、登录，即可参与活动。可根据情况选择参与其中的一项或多项活动，并于提交作品时完善个人及作品信息。
        </p>
        <p class="second-title">
          （三）作品推荐阶段：2022年5月1日至5月20日
        </p>
        <p>
          各组织单位可推荐本单位征集的“经典有声”原著（节选）诵读和“共享悦读”微书评作品参与专家研议，每类作品推荐数量不超过作品总数的10%。无组织单位的个人提交作品，将由主办单位负责组织推荐。
        </p>
        <p class="second-title">（四）专家研议阶段：2022年5月20日至5月31日</p>
        <p>
          专家将根据各组织单位推荐“经典有声”原著（节选）诵读和“共享悦读”微书评作品情况进行研议，并确定最终展示名单；阅读打卡和知识竞赛两项活动将根据阅读数据和答题成绩进行排名统计。
        </p>
        <p class="second-title">（五）活动总结及作品展示阶段：2022年6月1日至6月30日</p>
        <p>
          活动结果将在平台进行公布及展示，届时请关注相关事宜。
        </p>
      </div>
    </div>

    <!-- 推荐书籍 -->
    <div class="recommend-books">
      <div class="title-box l_flex_column_center">
        <h3>推荐书籍</h3>
        <img src="~@/assets/img/icon.png" class="icon" alt="" />
      </div>
      <div class="more_book">
        <router-link to="/index/activityBooks">更多书籍>></router-link>
      </div>
      <div class="container l_flex_row_center">
        <book class="item" v-for="(item, index) in recommentBooks" :obj="item" :key="index"></book>
      </div>
    </div>

    <!-- 优秀组织奖、优秀指导老师奖申报 -->
    <!-- <div class="awards-declaration">
      <img src="../../../assets/img/title3.png" alt="优秀组织奖、优秀指导老师奖申报" class="awards-title" />
      <div class="awards-content">
        <p>
          1、5月1日至5月31日期间，请各组织单位根据各馆活动组织情况及效果，申报“优秀组织奖”、“优秀指导老师奖”奖项。“优秀组织奖”以各高校图书馆为单位进行申请，“优秀指导老师奖”根据各馆活动开展情况推荐表现优异的组织、指导老师，每馆最多2个名额。
        </p>
        <p>
          2、申报表参考文档可于活动平台首页进行下载，于规定时间内提交至活动组工作邮箱（
          3211758706@qq.com）。邮件主题请以“所在高校名称＋奖项申报”命名。
        </p>
      </div>
    </div> -->
    <!-- 奖项设置 -->
    <!-- <div class="award-setting">
      <div class="title-box l_flex_column_center">
        <h3>奖项设置</h3>
        <img src="~@/assets/img/icon.png" class="icon" alt="" />
      </div>
      <div class="container l_flex_row_center">
        <img src="../../../assets/img/jxsz.png" alt="" />
      </div>
    </div> -->

    <!-- 活动要求 -->
    <div class="activity-require">
      <div class="title-box l_flex_column_center">
        <h3>活动说明及要求</h3>
        <img src="~@/assets/img/icon.png" class="icon" alt="" />
      </div>
      <div class="container">
        <p>1、本次活动为公益性阅读推广活动，不向组织单位或参与者收取任何费用。</p>
        <p>
          2、活动将提供统一的宣传海报设计图、微信推文稿用于校内宣传，各组织单位可将活动平台嵌入本单位微信公众号，设置“百部经典校园行”栏目。宣传物料及相关文件可在活动首页“活动资料下载”专区获取。
        </p>
        <p>
          3、请各组织单位利用校园网、微信公众号、微信群、QQ群、线下社团、学生会等途径开展宣传活动，组织本校学生积极参与。
        </p>
        <p>
          4、活动中个人或组合提交作品，即表明同意其作品无偿授权于本活动各组织机构（主办、组织、支持单位）用于非营利性/公益用途，包括以单独或汇编作品形式进行线上及线下展播、媒体报道、网络推广等。相关授权期限为永久授权。
        </p>
        <p>
          5、提交作品应坚持社会主义核心价值观，符合国家相关法律法规要求，为本人的原创作品或经合法授权的作品，无任何权利瑕疵，不侵犯任何第三人的合法权益，保证主办方免受任何第三方的损失索赔。凡涉及的包括但不限于知识产权、肖像权、名誉权、隐私权等法律责任由创作者本人（或其监护人）承担。创作者的投稿行为即表明同意上述权利声明及责任承担方式。
        </p>
      </div>
    </div>
    <!-- 联系方式 -->
    <div class="contact">
      <div class="title-box l_flex_column_center">
        <h3>活动联系方式</h3>
        <img src="~@/assets/img/icon.png" class="icon" alt="" />
      </div>
      <!-- <div class="container"></div> -->
      <h5 class="text_center title">（一）语林云活动平台：宋老师</h5>
      <p class="text_center">电话：400-969-6261 17730043623</p>
      <p class="text_center">邮箱：3211758706@qq.com</p>
      <p class="text_center">QQ：3211758706</p>
      <h5 class="text_center title">（二）中国图书馆学会秘书处：张老师</h5>
      <p class="text_center">联系电话：010-88544671</p>
      <h5 class="text_center title">活动交流群</h5>

      <p class="text_center">大赛读者QQ交流一群：128083991（已满）</p>
      <p class="text_center">大赛读者QQ交流二群：550764575（已满）</p>
      <p class="text_center">大赛读者QQ交流三群：601915501（已满）</p>
      <p class="text_center">大赛读者QQ交流四群：641067461（已满）</p>
      <p class="text_center">大赛读者QQ交流五群：964310145</p>
      <p class="text_center">组织高校QQ交流群：796788255</p>
      <p class="text_center tip">*若以上QQ群因满员问题无法进入，将在活动平台通知新增群号。</p>
    </div>
  </div>
</template>

<script>
import ActHeader from "@/components/ActHeader.vue";
import ActivityBanner from "@/components/ActivityBanner";
import navbox from "@/components/navbox";
import book from "@/components/book";
import ActFooter from "@/components/ActFooter";
import ActivityItem from "@/views/pages/home/component/ActivityItem";

const read_img = require("../../../assets/img/yddk_banner.jpg");
const recite_img = require("../../../assets/img/jdys_banner.jpg");
const bookreview_img = require("../../../assets/img/gxyd_banner.jpg");
const answer_img = require("../../../assets/img/dtjs_banner.jpg");
import store from "@/store/index";
export default {
  components: {
    ActHeader,
    ActivityBanner,
    navbox,
    book,
    ActFooter,
    ActivityItem,
  },
  props: {},
  data() {
    return {
      // recommentBooks: [],
      activityList: [
        {
          key: 0,
          id: 374,
          cover: read_img,
          title: "《百部经典》阅读打卡活动",
          content:
            "在平台提供的多本电子版图书中，由读者选择性阅读，点击阅读即视为参加本场活动。活动将根据各读者的的总打卡天数、阅读时间等显示个人综合排名，排行榜实时更新。",
        },
        {
          key: 1,
          id: 375,
          cover: recite_img,
          title: "“经典有声”原著（节选）诵读展示活动",
          content:
            "在平台推荐的《百部经典》书目中，节选任意片段进行诵读演绎。作品创作可选择音频和视频2种类型，内容、形式不作过多限制。可采用直接录制、或剪辑处理、或画面/背景乐添加等一系列视听表达效果与作品相结合的方式。",
        },
        {
          key: 2,
          id: 376,
          cover: bookreview_img,
          title: "“共享悦读”微书评荐书推广活动",
          content:
            "在平台推荐的《百部经典》系列丛书书单中任选1本或多本阅读，根据所选书籍创作“微评”内容。所述观点要求积极向上，弘扬正能量，坚持正确的政治立场和舆论导向。",
        },
        {
          key: 3,
          id: 377,
          cover: answer_img,
          title: "“百部经典·百题大闯关”传统文化知识竞赛",
          content:
            "每轮答题将由题库随机抽取20道选择题，每答对一题得5分，总分100分。按成绩实时显示排行榜。若分数相同，则以答题时间由短到长进行排序。每人最多可进行2轮答题，多轮答题者以单轮最高成绩作为排行标准。排行榜实时更新。",
        },
      ],
      shareData: store.state,
    };
  },
  watch: {
    store: {
      handler(val, oldval) {
        // console.log("activitylist监听 ", val);
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    recommentBooks() {
      return this.shareData.recommend_book;
    },
  },
  methods: {
    async getRecommendBoock() {
      try {
        let res = await this.$mock.getRecommendBooks();
        // console.log("end", res);
        this.recommentBooks = res.list.slice(0, 4);
      } catch (error) {
        console.log("err", error);
      }
    },
  },
  created() {
    // this.getRecommendBoock();
    // console.log("活动", store.state.activityList);
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.wrapper {
  .activity_summary {
    width: 1200px;
    min-width: 1200px;
    margin: 0 auto;
    .title {
      text-align: center;
      font-size: 32px;
      font-weight: bold;
      color: #835851;
    }
    .icon {
    }
    .text {
      line-height: 2.5;
      font-size: 18px;
    }
  }

  // 活动规则介绍
  .activity_rule {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    &_title {
      margin: 0 auto;
    }
    .title {
      font-weight: bold;
      font-size: 30px;
      color: #835851;
    }
  }

  .activity_process {
    .title {
      text-align: center;
      font-size: 32px;
      font-weight: bold;
      color: #835851;
    }
    .time-con {
      width: 1200px;
      margin-top: 40px;
      height: 320px;
      .time-box {
        width: 250px;
        height: 221px;
        background-image: url("~@/assets/img/gc_bg.png");
        background-size: cover;
        background-repeat: no-repeat;
        text-align: center;
        &-title {
          margin-top: 60px;
          font-weight: bold;
          font-size: 18px;
        }
        .line {
          width: 20px;
          height: 1px;
          margin: 0 auto;
          background-color: #333;
        }
        &:nth-child(2) {
          // margin: 0 150px;
          align-self: flex-end;
          position: relative;
          .right_icon {
            position: absolute;
            left: -160px;
            top: 60px;
          }
          .right_icon1 {
            position: absolute;
            right: -160px;
            top: 60px;
          }
        }
      }
    }
    .content {
      width: 1200px;
      margin: 0 auto;
      font-size: 18px;
      .second-title {
        font-weight: bold;
        color: #805648;
      }
      p {
        line-height: 2.5;
      }
    }
  }
  //
  .awards-declaration {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    .awards-content {
      margin-top: 65px;
      line-height: 48px;
      font-size: 18px;
    }
  }

  .award-setting {
    .title-box {
      font-size: 32px;
      font-weight: bold;
      color: #835851;
    }
    .container {
      margin-top: 50px;
      .second {
        width: 200px;
        height: 410px;
        background-image: url("~@/assets/img/box2.jpg");
        background-size: cover;
        background-repeat: no-repeat;
      }
      .first {
        margin: 0 150px;
        width: 250px;
        height: 510px;
        background-image: url("~@/assets/img/box1.jpg");
        background-size: cover;

        background-repeat: no-repeat;
      }
      .third {
        width: 200px;
        height: 410px;
        background-image: url("~@/assets/img/box2.jpg");
        background-size: cover;
        background-repeat: no-repeat;
      }
    }
  }
  .recommend-books {
    width: 1200px;
    min-width: 1200px;
    margin: 40px auto 100px;
    position: relative;
    .more_book {
      position: absolute;
      top: 60px;
      right: 0;
      color: #815a4e;
      a {
        color: #815a4e;
      }
    }
    .title-box {
      font-size: 32px;
      font-weight: bold;
      color: #835851;
      h3 {
        margin-bottom: 10px;
      }
    }
    .container {
      margin-top: 40px;
      .item {
        width: calc((1200px - (3 * 50px)) / 4);
        margin-right: 50px;
        &:nth-child(4n) {
          margin-right: 0;
        }
      }
    }
  }

  .activity-require {
    margin-top: 40px;
    .title-box {
      font-size: 32px;
      font-weight: bold;
      color: #835851;
      h3 {
        margin-bottom: 10px;
      }
    }
    .container {
      width: 1200px;
      min-width: 1200px;
      margin: 30px auto;
      line-height: 48px;
      font-size: 18px;
    }
  }

  .contact {
    .title-box {
      // font-size: 18px;
      font-weight: bold;
      color: #835851;
      h3 {
        font-size: 36px;
        font-weight: bold;
        margin-bottom: 10px;
      }
    }
    .text_center {
      text-align: center;
    }
    .title {
      color: #805b4b;
      font-size: 20px;
      font-weight: bold;
    }
    p {
      font-size: 18px;
    }
    .tip {
      color: #815a4e;
      font-size: 18px;
      margin-bottom: 150px;
    }
  }
}
</style>
